const normalizePublicCode = (value?: string | null) => {
  if (typeof value !== "string") {
    return null;
  }

  const normalized = value
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  return normalized.length > 0 ? normalized : null;
};

export const formatPublicCode = (value?: string | null) => {
  const normalized = normalizePublicCode(value);
  if (!normalized) {
    return null;
  }

  return normalized.replace(/(.{4})/g, "$1-").replace(/-$/, "");
};
